import PrestadorDetalheService from "./PrestadorDetalheService";

export default {
  mixins: [PrestadorDetalheService],
  data() {
    return {
      idRnpPrestador: -1,
      objetoPrestador: {
        codigoPrestador: 0,
        nomePrestador: "",
        documento: "",
        tipo: "",
        unimed: "",
        status: "",
        rede: "",
        dataProgramada: ""
      },
      loadingPrestador: false,
      podeAprovarReprovar: false,
      podeEnviarArquivo: false,
      codigoUnimed: "",
      iniciado: false,
      exibeAbaDeExclusao: false
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.recuperarIdRnpPrestador();
      this.inicializarPrestador();
    },
    recuperarIdRnpPrestador() {
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
    },
    inicializarPrestador() {
      this.loadingPrestador = true;
      this.sleep(150).then(() => {
        this.getDetalhePrestador(this.idRnpPrestador)
          .then(res => {
            const {
              codigo: codigoPrestador,
              cpfCnpj: documento,
              dtExclusaoProgramada: dataProgramada,
              nome: nomePrestador,
              rede: { descricao: descricaoRede },
              status: { chave: chaveStatus },
              tipo: { descricao: descricaoTipo },
              unimedOrigem: unimed,
              podeAprovarReprovar,
              podeEnviarArquivo,
              exibeAbaDeExclusao,
              dtEnvioExclusao,
              nomeArquivoExclusao
            } = res.data;

            console.log("detalhe", res.data);

            this.$set(this, "objetoPrestador", {
              codigoPrestador,
              nomePrestador,
              documento,
              tipo: descricaoTipo,
              unimed,
              status: chaveStatus,
              rede: descricaoRede,
              dataProgramada: this.$helpers.formatadorDataSafe(dataProgramada),
              dtEnvioExclusao,
              nomeArquivoExclusao
            });

            this.$store.commit("setPrestador", res.data);

            this.podeAprovarReprovar = podeAprovarReprovar;
            this.podeEnviarArquivo = podeEnviarArquivo;
            this.exibeAbaDeExclusao = exibeAbaDeExclusao;

            this.codigoUnimed = unimed.substring(0, unimed.indexOf("-") - 1);
          })
          .catch(() => {
            this.$set(this, "objetoPrestador", {
              codigoPrestador: "",
              nomePrestador: "",
              documento: " - ",
              tipo: " - ",
              unimed: " - ",
              status: "",
              rede: " - ",
              dataProgramada: " - "
            });
          })
          .finally(() => {
            this.loadingPrestador = false;
            this.iniciado = true;
          });
      });
    }
  }
};
